import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

// window.ENV is emitted by the root route. When the root loader itself fails,
// the error boundary renders without it, so this read has to tolerate its
// absence — otherwise the whole client bundle throws here and the error page
// never hydrates (its "Try again" button would do nothing).
if (window.ENV?.MODE === "production" && window.ENV?.SENTRY_DSN) {
  import("./utils/monitoring.client.js").then(({ init }) => init());
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
